import React from 'react'
import Image_1 from '../.././Work-Assets/Web_Images/Image-1.jpeg';
import Image_2 from '../.././Work-Assets/Web_Images/Image-2.jpeg';
import Image_3 from '../.././Work-Assets/Web_Images/Image-3.jpeg';
import Image_4 from '../.././Work-Assets/Web_Images/Image-4.jpeg';



function Web_images() {
  return (
    <div className='layout_IMG_FL'>

    <div className='layout_IMG'>
      <div className='layout_IMG_img'>
        <img src={Image_1} />
      </div>
      
      <p className='p_web_img'>“Connecting with the MKU Student Council to better understand the real needs of students—because Hostel Adventures is all about creating a home away from home.”</p>
    </div>

    <div className='layout_IMG'>
      <div className='layout_IMG_img'>
        <img src={Image_2} />
      </div>
      <p className='p_web_img'>"The passionate team behind Hostel Adventures—committed to redefining student housing with comfort, care, and community."</p>
    </div>

    <div className='layout_IMG'>
      <div className='layout_IMG_img'>
        <img src={Image_3} />
      </div>
      <p className='p_web_img'>“An honor to stand with the President and Vice President of Mount Kenya University—grateful for their continued support and partnership.”</p>
    </div>
    
    <div className='layout_IMG_FL_NONE'>
     <div className='layout_IMG'>
      <div className='layout_IMG_img_POSTER'>
        <img src={Image_4} />
      </div>
    
    </div>
    </div>
    
    </div>
  )
}

export default Web_images
